import React from "react"
import { AutocompleteRenderGetTagProps } from "@mui/material"

import { Tag } from "../../atoms"

export const renderTags:TRenderTags = (value, getTagProps, renderTag) =>
  value.map((option, index) => {
    const labelValue = renderTag(option)
    return (
      <Tag
        variant="outlined"
        color={"default"}
        label={labelValue}
        {...getTagProps({ index })}
        key={index}
      />
    )
  })

type TRenderTags = (
  value: unknown[],
  getTagProps: AutocompleteRenderGetTagProps,
  renderTag: (value: unknown) => string,
) => React.ReactElement | React.ReactElement[]